angular.module('assets')
    .component('conditionIco', {
        bindings: {
            condition: '<'
        },
        template: `
            <span ng-switch="$ctrl.condition" title="{{ 'asset.condition.'.concat($ctrl.condition) | translate }}">
                <span ng-switch-when="GOOD"><i class="fa fa-fw fa-lg fa-thumbs-up" style="color: #1b7e5a"></i></span>
                <span ng-switch-when="CORRECT"><i class="fa fa-fw fa-lg fa-meh-o" style="color: #0a0"></i></span>
                <span ng-switch-when="BAD"><i class="fa fa-fw fa-lg fa-thumbs-down" style="color: #c00"></i></span>
                <span ng-switch-when="UNDER_REPAIR"><i class="fa fa-lg fa-fw fa-wrench" style="color: #d28642"></i></span>
                <span ng-switch-default></span>
            </span>
        `
    })
